export function timeToDate(time){
    // return new Date(time).toLocaleTimeString()
    return Math.floor(time/3600000).toLocaleString('fr-FR', {
        minimumIntegerDigits: 2,
        useGrouping: false
    })+':'+Math.floor((time%3600000)/60000).toLocaleString('fr-FR', {
        minimumIntegerDigits: 2,
        useGrouping: false
    })
}